import * as React from 'react';
import * as Header from '../constants/Header';
import { Message } from 'element-react';
import '../common/css/reset.css';
import '../common/css/cmn_layout.css';
import '../common/css/cmn_style.css';
import '../css/admin_menu.css';

interface MenuProps extends React.Props<{}> {
  headerActions: any;
  authActions: any;
}

class Menu extends React.Component<MenuProps, {}> {
  componentWillMount() {
    document.title = 'メニュー画面';

    this.props.headerActions.setPage(Header.ADMIN_MENU);
  }
  handleSignOut = () => {
    Message.info('ログアウトしました');
    this.props.authActions.signOut();
  }

  render() {
    return (
      <div className="menu_wrap">
        <h2>メニュー画面</h2>
        <ul className="adminMenuList">
          <li>
            <a href="patients">
              顧客一覧
              <i className="fas fa-chevron-right" />
            </a>
          </li>
          {/* <li>
            <a href="doctors">
              医師一覧
              <i className="fas fa-chevron-right"/>
            </a>
          </li> */}
          <li>
            <a href="hospitals">
              医療機関一覧
              <i className="fas fa-chevron-right"/>
            </a>
          </li>
          <li>
            <a href="inquiries">
              問い合わせ一覧
              <i className="fas fa-chevron-right"/>
            </a>
          </li>
          <li>
            <a onClick={event => this.handleSignOut()}>
              ログアウト
              <i className="fas fa-chevron-right"/>
            </a>
          </li>
          <style type="text/css">
            {'h1, h2 { font-weight: bold; }'}
            {'h2 { line-height: 1.75; }'}
            {'#wrapper .contentIn { width: 750px; padding: 80px 0; }'}
            {'#wrapper .contentIn .menuList { padding: 20px; }'}
          </style>
        </ul>
      </div>

    );
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Menu.tsx